import { db } from '@/utils/Indexdb';

const userstr = localStorage.getItem('React-ant-Admin-user');
const userinfo = userstr ? JSON.parse(userstr) : {};

let stagingTime = localStorage.getItem('SERVER_STATG_TIME')
  ? Number(localStorage.getItem('SERVER_STATG_TIME'))
  : Date.now();

export const indexdb = {
  max: 30, // 100 lines
  age: 2592000000, // 30days
  // age: 600000, // 10 mins for test
  setData: async (key: string, value: string) => {
    const newDate = Date.now();
    const res = await db.serverList.where('url').equalsIgnoreCase(key);
    res.delete();
    if (newDate - stagingTime > indexdb.age) {
      indexdb.clearTable();
      localStorage.setItem('SERVER_STATG_TIME', String(Date.now()));
    } else {
      await indexdb.countTable();
    }
    await db.serverList.add({
      url: key,
      serverStr: value
    });
  },
  getData: async (key: string) => {
    const res = await db.serverList.where('url').equalsIgnoreCase(key).toArray();
    console.log(res);
    return res[0];
  },
  clearTable: async () => {
    await db.serverList.clear();
  },
  countTable: async () => {
    const tableCount = Number((await db.serverList.count()).toString());
    console.log(tableCount);
    if (tableCount > indexdb.max) {
      indexdb.clearTable();
    }
  }
};

window['indexdb'] = indexdb;

const storage = {
  hasLargeData: () => {
    return typeof (window as any).raw.bigData === 'function';
  },
  // large data
  largeDataSet: (key: string, value: string) => {
    return new Promise((resolve, reject) => {
      (window as any).raw.bigData({ key, value, op: 'insert' }, (res: any) => {
        if (res.status === 'resolve') {
          resolve(res.data);
        }
        if (res.status === 'reject') {
          reject(res.data);
        }
      });
    });
  },
  largeDataGet: (key: string) => {
    return new Promise((resolve, reject) => {
      (window as any).raw.bigData({ key, op: 'query' }, (res: any) => {
        if (res.status === 'resolve') {
          resolve(res.data);
        }
        if (res.status === 'reject') {
          resolve('');
        }
      });
    });
  },
  // 存储数据
  electronSetData: (key: string, params: string) => {
    return new Promise((resolve, reject) => {
      (window as any).raw.setStorage({ key, params }, (res: any) => {
        if (res.status === 'resolve') {
          resolve(res.data);
        }
        if (res.status === 'reject') {
          reject(res.data);
        }
      });
    });
  },
  // 存储数据 - 语音社区用
  electronSetDataVoice: (key: string, params: string) => {
    return new Promise((resolve, reject) => {
      (window as any).raw.setStorage({ key, params }, (res: any) => {
        if (res.status === 'resolve') {
          resolve(200);
        }
        if (res.status === 'reject') {
          reject(500);
        }
      });
    });
  },
  // 读取数据
  electronGetData: (key: string) => {
    return new Promise((resolve, reject) => {
      (window as any).raw.getStorage({ key }, (res: any) => {
        if (res.status === 'resolve') {
          resolve(res.data);
        }
        if (res.status === 'reject') {
          reject(res.data);
        }
      });
    });
  },
  // 删除数据
  electronDelData: (key: string) => {
    return new Promise((resolve, reject) => {
      (window as any).raw.delStorage({ key }, (res: any) => {
        if (res.status === 'resolve') {
          resolve(res.data);
        }
        if (res.status === 'reject') {
          reject(res.data);
        }
      });
    });
  },
  // 登出页面
  electronLogout: () => {
    try {
      (window as any).raw.controlOB({ operation: 'remove' });
    } catch (e) {
      console.warn('no controlOB, please check version', e);
    }
    return new Promise((resolve, reject) => {
      (window as any).raw.logoutWindow({}, (res: any) => {
        if (res.status === 'resolve') {
          resolve(res.data);
        }
        if (res.status === 'reject') {
          reject(res.data);
        }
      });
    });
  },
  // 下载更新
  electronUpdate: (url: string, cb: Function | null, control?: string, isHot?: boolean) => {
    return new Promise((resolve, reject) => {
      (window as any).raw.downloadUpdateAuto({ url, control, isHot }, (res: any) => {
        if (res.status === 'resolve') {
          resolve(res.data);
        }
        if (res.status === 'reject') {
          reject(res.data);
        }
        if (res.status === 'info' && cb) {
          cb(res.data);
        }
      });
    });
  },
  // 新窗口打开页面
  electronOpenPage: (pageInfo: any) => {
    const { url, width, height } = pageInfo;
    return new Promise((resolve, reject) => {
      (window as any).raw.createWindow(
        {
          url: url,
          width: width,
          height: height,
          minW: width,
          minH: height
        },
        (res: any) => {
          if (res.status === 'resolve') {
            resolve(res.data);
          }
        }
      );
    });
  },
  // 打开更新窗口
  electronOpenUpgrade: (updateInfo: any) => {
    return new Promise((resolve, reject) => {
      (window as any).raw.openDownloadWindow({ updateInfo }, (res: any) => {
        if (res.status === 'resolve') {
          resolve(res.data);
        }
        if (res.status === 'reject') {
          reject(res.data);
        }
      });
    });
  },
  // 打开activity窗口
  electronOpenActivity: (url: string, cutLegendEntryType?: string, target?: string) => {
    return new Promise((resolve, reject) => {
      let createUrl = `${url}&deviceid=${localStorage.getItem('deviceIdEle')}&target=${target}`;
      if (createUrl.indexOf('appv') === -1) {
        createUrl += `&appv=${localStorage.getItem('appv')}`;
      }
      if (createUrl.indexOf('device=') === -1) {
        createUrl += `&device=pc`;
      }
      if (createUrl.indexOf('token') === -1) {
        createUrl += `&token=${userinfo.token}`;
      }
      (window as any).raw.controlOB(
        {
          width: 375 + 8,
          height: 812 + 10,
          x: (window.innerWidth - 382) / 2,
          y: (window.innerHeight - 812) / 2,
          target: 'main',
          operation: 'create',
          needFrame: 1,
          url: createUrl
        },
        (res: any) => {
          if (res.hasWindow) {
            resolve('hasWindow');
          } else {
            resolve('success');
          }
        }
      );
    });
  },
  electronCloseActivity: () => {
    if ((window as any).raw.controlOB) {
      (window as any).raw.controlOB({ operation: 'remove' });
    }
  },
  electronDownloadFile: (data: { url: string; filePath?: string; rename?: string }) => {
    const { url, filePath, rename } = data;
    return new Promise((resolve, reject) => {
      // 检查 downloadFile 方法是否存在
      if (!(window as any).raw || typeof (window as any).raw.downloadFile !== 'function') {
        reject(new Error('downloadFile 方法不可用'));
        return;
      }
      (window as any).raw.downloadFile({ url, filePath, rename }, (res: any) => {
        if (res.status === 'resolve') {
          resolve(res.data);
        }
        if (res.status === 'reject') {
          reject(res.message);
        }
      });
    });
  },
  electronRunFile: (filePath: string) => {
    return new Promise((resolve, reject) => {
      (window as any).raw.runFile({ filePath }, (res: any) => {
        if (res.status === 'resolve') {
          resolve(res.data);
        }
        if (res.status === 'reject') {
          reject(res.message);
        }
      });
    });
  },
  electronSwitchNetWork: () => {
    return new Promise((resolve, reject) => {
      (window as any).raw.switchNetwork({}, (res: any) => {
        if (res.status === 'resolve') {
          resolve(res.data);
        }
        if (res.status === 'reject') {
          reject(res.message);
        }
      });
    });
  }
};
const StorageFn = new Proxy(storage, {
  get: (target, propKey, receiver) => {
    if (!(window as any).raw) {
      return () => {
        return new Promise((resolve, reject) => {
          resolve('');
        });
      };
    }
    return Reflect.get(target, propKey, receiver);
  }
});
export default StorageFn;
